import React from 'react';

import {LAZY_LOAD_OFFSET} from '../../../utils/constants';
import LazyLoad from '../../../components/common/lazy-load/LazyLoad';

import {CHEVRON_RIGHT__12} from '@homeaway/svg-defs';
import {SVGIcon} from '@homeaway/react-svg';

import {AspectRatioCard} from '@homeaway/react-aspect-ratio-card';

export function Card({
    title,
    imgUrl,
    overview,
    isMobile,
    readMore,
    path,
    altText,
}) {
    const offset = LAZY_LOAD_OFFSET[isMobile ? 'MOBILE' : 'DEFAULT'];
    return (
        <AspectRatioCard aspectRatio={'4x3'} key={imgUrl} hasHover={false}>
            <div
                data-slot={'figure'}
                className="media-flex media-flex--left image"
            >
                <LazyLoad offset={offset}>
                    <img className="img-circle" src={imgUrl} alt={altText} />
                </LazyLoad>
            </div>
            <div className="media-flex__content" data-slot={'content'}>
                <div className="media-flex__body">
                    <h4 className="no-margin">{title}</h4>
                </div>
                <div className="media-flex__footer">{overview}</div>
                <a className="read-more" href={path}>
                    {readMore}
                    <SVGIcon markup={CHEVRON_RIGHT__12} inlineFlex />
                </a>
            </div>
        </AspectRatioCard>
    );
}
